import { useMemo } from "react";
import { AUTH_TOKEN_NAME } from "@timeedit/ui-components/lib/src/components/AuthWrapper/constants";
import { clearRemoteAuthTokenSilently } from "@timeedit/ui-components/lib/src/components/AuthWrapper/utils/tokenUtils";
import { getAuthUrl, getIsAdmin } from "@services/auth.service";
import { storageService } from "@services/storage.service";
import { useAuthStore } from "@src/providers/auth.provider";
import useGlobalLoader from "./globalLoader.hook";

export default function useUser() {
  const { user } = useAuthStore();

  const isAdmin = useMemo(
    () => (user ? getIsAdmin(user.roles) : false),
    [user]
  );

  const { removeFromStorage } = storageService("local");
  const NODE_ENV = process.env.NODE_ENV;

  /** 
    Simplified copy of the logout function from the TE AUTH wrapper
    Will be using this until TE Auth has integrated proper loader animations
   */
  const { setIsLoading } = useGlobalLoader();
  const logout = async () => {
    if (!user) return;

    setIsLoading(true);
    removeFromStorage(AUTH_TOKEN_NAME);
    await clearRemoteAuthTokenSilently(
      getAuthUrl(NODE_ENV),
      NODE_ENV === "development"
    );

    setIsLoading(false);
    location.reload();
  };

  return { user, isAdmin, logout };
}
